export default __webpack_public_path__ + "c1d7e78add8bf86f6c6098f53774818c.svg";